module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6a5e329289e7673e9b8a2ff9da62cb22.gif";